import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-298579e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark fixed-top" }
const _hoisted_2 = { class: "container pt-1 pb-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse ms-5",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav me-auto" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Activate code")
const _hoisted_11 = { class: "navbar-nav ms-auto" }
const _hoisted_12 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Sign up")
const _hoisted_14 = {
  key: 1,
  class: "nav-item TumiMargin"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Log in")
const _hoisted_16 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Portal")
const _hoisted_18 = {
  key: 3,
  class: "nav-item TumiMargin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToHow && _ctx.ToHow(...args)), ["prevent"])),
              "data-bs-toggle": "collapse",
              "data-bs-target": ".navbar-collapse.show"
            }, "How does it work?")
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("a", {
              class: "nav-link",
              href: "#",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToContact && _ctx.ToContact(...args)), ["prevent"])),
              "data-bs-toggle": "collapse",
              "data-bs-target": ".navbar-collapse.show"
            }, "Contact")
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: {path:'/ActivateCode'},
              class: "nav-link code TumiOrange"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("ul", _hoisted_11, [
          (!_ctx.Logged)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: {path:'/SignUp'},
                  class: "btn btn-info me-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.Logged)
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: {path:'/Login'},
                  class: "btn btn-info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.Logged)
            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                _createVNode(_component_router_link, {
                  to: {path:'/Portal'},
                  class: "btn btn-info me-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.Logged)
            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                _createElementVNode("a", {
                  class: "btn btn-info",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.Logout && _ctx.Logout(...args))),
                  href: "#"
                }, "Logout")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}